<script>
    export let src;
    export let alt;
    export let width;
    export let height;
    export let imageSizes;
    export let classes = '';
    export let lcp = false;
    export let lazy = true;
    export let lqip = undefined;

    // Initalize isImageLoading depending on if lqip is provided.
    $: isImageLoading = lqip ? true : false;

    // Bind the dom image element
    let imageElement;
    let completedAfterHydration;

    // If the image load is completed, and lqip was provided, set to false.
    $: if (lqip && (imageElement?.complete || completedAfterHydration)) {
        isImageLoading = false;
    }

    const breakpoints = ['640px', '1024px', ''];

    // Generate sources object from imageSizes with breakpoints
    const sources = imageSizes.map((size, index) => ({
        screen: breakpoints[index],
        width: size
    }));

    // CDN Specific url + appends
    const cdnUrl = (imageSrc, size) => {
        const url = new URL(imageSrc);
        if (url.host === 'cdn.shopify.com') {
            url.searchParams.append('width', size);
        } else if (url.host === 'cdn.sanity.io') {
            url.searchParams.append('auto', 'format');
            url.searchParams.append('w', size);
        }
        return url.toString();
    };

    // calculate dpr width and cap at 1920 wide
    const dprWidth = (srcWidth, multiplier) => {
        const dprWidth = Math.min(Number(srcWidth) * multiplier, 1920);
        return dprWidth;
    };
</script>

<div class="{classes} {isImageLoading ? 'lqip' : ''}" style={isImageLoading ? `--lqip_url: url(${lqip})` : null}>
    <picture>
        {#each sources as source (source)}
            <source
                srcset="{cdnUrl(src, source.width)},
                    {cdnUrl(src, dprWidth(source.width, 2))} 2x"
                media={`${source.screen !== '' ? `(max-width: ${source.screen})` : ''}`}
            />
        {/each}
        <img
            {src}
            {alt}
            {width}
            {height}
            class={classes}
            loading={lazy ? 'lazy' : null}
            fetchpriority={lcp ? 'high' : null}
            decoding={lazy ? 'async' : null}
            bind:this={imageElement}
            on:load={() => {
                completedAfterHydration = true;
            }}
        />
    </picture>
</div>

{#if isImageLoading}
    <style>
        .lqip {
            background-image: var(--lqip_url);
            background-repeat: no-repeat;
            background-size: cover;
        }
    </style>
{/if}
